export default __webpack_public_path__ + "static/media/calculator.e20144ff.png";